import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CRMCampaignService,
  FunnelStepService,
  MerchantService,
  RefundReportService,
  ReportsConfigService,
  RetentionReportService,
  StorageService,
  UserService,
  CancelReasonCategoryService
} from "../_services";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import { ReportsAbstractV2Component } from "./reports-abstract-v2.component";
import { MultiOptions } from "../custom-multi-select/multi-select";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  fields,
  filters, RmaRetentionReportsExtraFields, RmaRetentionReportsExtraFilters,
} from './utils/constants';
import { cloneDeep } from "lodash";
import { ReportDimensionCategories, ReportDimensions, ReportTypes } from "./models/reports";
import {Observable} from 'rxjs';

@Component({
  moduleId: module.id.toString(),
  selector: "return-retention-report-v2",
  templateUrl: "./templates/reports-v2.component.html",
  styleUrls: ["./styles/reports-v2.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ReturnRetentionReportV2Component
  extends ReportsAbstractV2Component
  implements OnInit, AfterViewInit
{
  reportTitle = "Return Retention Report";
  fields: MultiOptions = cloneDeep(fields);
  filters: MultiOptions = cloneDeep(filters);
  reportType = ReportTypes.RETURN_RETENTION;

  commonReportsFields = [
    "rma_request",
    "rma",
    "rma_save",
    "rma_request_abandoned"
  ];
  summaryFields = [
    "session_count",
    "rma_request",
    "rma",
    "rma_save",
    "save_amount",
    "amount_paid",
    "rma_save_rate",
  ];
  selectedDimensions = [
    {
      model: "rma_path",
      label: "Customer Stage",
      selected: true,
      disabled: false,
    }
  ];
  fieldsToExcludeFromReport: string[] = ['step_name', 'step_slug'];
  fieldsNotHavingEmptyValue = [ReportDimensions.CancelReason, ReportDimensions.LastRMAStep,
    ReportDimensions.LastRMAInput];
  switchFilterKeyMapping = [
    {from: ReportDimensions.ProductPath, to: ReportDimensions.RMAPath},
    {from: ReportDimensions.InputName, to: ReportDimensions.LastRMAInput},
  ]
  showExcludeUpsellsFilter = true;
  showExcludeValidationsFilter = true;
  showRetentionOnlyFilter = true;
  retentionOnlyFlag = 'rma_only';
  retentionOnlyLabel = 'Show only Returns';

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    public reportsService: RetentionReportService,
    protected modalService: NgxSmartModalService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected refundReportService: RefundReportService,
    protected merchantService: MerchantService,
    protected cancelReasonCategoryService: CancelReasonCategoryService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService
    );

    this.fields[ReportDimensionCategories.Dimensions].options.find((x) => x.model === ReportDimensions.ProductPath).model =
    ReportDimensions.RMAPath;
    this.fields[ReportDimensionCategories.Dimensions].options.find((x) => x.model === ReportDimensions.InputName).model =
      ReportDimensions.LastRMAInput;
    this.updatePreSelectedDimensions([ReportDimensions.RMAPath]);
    this.filterCommonDimensions(this.commonReportsFields);
    this.fields[ReportDimensionCategories.Dimensions].options =
      this.fields[ReportDimensionCategories.Dimensions].options.concat(RmaRetentionReportsExtraFields)
    this.filters = this.filters.concat(RmaRetentionReportsExtraFilters)
  }

  ngOnInit() {
    super.ngOnInit();

  }

  ngAfterViewInit() {
    if (this.panel) {
      this.panel.expanded = true;
    }
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(
      this.selectedDimensions,
      event.previousIndex,
      event.currentIndex
    );
  }

  getQueryForSummary() {
    const query = super.getQueryForSummary();
    query['report_type'] = this.reportType;
    this.switchFilterKeys(query);
    return query;
  }

  getQueryForReport() {
    const query = super.getQueryForReport();
    query['report_type'] = this.reportType;
    this.switchFilterKeys(query);
    this.applyExcludeEmptyValueFilter(query);
    return query;
  }

  getSummaryApiCalls(): Observable<any> {
    return this.reportsService.getSummary(this.getQueryForSummary());
  }
}
